<template>
  <div style="position: relative;height:94.7vh">
    <span class="return" @click="$router.back()"><<返回</span>
    <iframe src="http://local.vrmaker.vip:38080/web-bim/gis.html" frameborder="0" width="100%" height="100%"></iframe>
  </div>
</template>

<script>


import {BimfaceSDKLoader,BimfaceSDKLoaderConfig,Glodon} from 'bimfacesdkloader'

export default {
  name: 'HelloWorld',
  data () {
    return {
        
    }
  },
  mounted(){

    const dom = this.$refs.bfContainer;

    let viewer3D;
    let app;
    let model3D;
    let viewToken = "440a8bf641aa46109c2ef5b81785369c";
    // 初始化显示组件
    let options = new BimfaceSDKLoaderConfig();
    options.viewToken = viewToken;
    BimfaceSDKLoader.load(options).then((viewMetaData)=>{
      let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
        webAppConfig.domElement = dom;
            // 创建WebApplicationGIS
        app = new Glodon.Bimface.Application.WebApplicationGIS(webAppConfig);
        // 加载待显示的场景
        app.addScene(viewToken);
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
/deep/.gld-bf-information{
  display: none;
}
.return{
    position: absolute;
    top: 22px;
    right: 194px;
    z-index: 9999;
    font-size: 21px;
    color: #fff;
    cursor: pointer;
}
h1, h2 {
  font-weight: normal;
}
.hello{
  height: 94vh;;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>




// WEBPACK FOOTER //
// src/views/gis.vue